import { useMutation, useQuery } from '@tanstack/react-query';

import { UserApi } from '../api';
import { IRole, IRoleCreate, IRoleUpdate } from '../models';

import { QueryKeys } from '@/constants/queryKeys';


export const useUserRolesQuery = () => {
  return useQuery({
    queryKey: [QueryKeys.roles],
    queryFn: () => UserApi.listRoles(),
    select: (response) => response.data.data,
  });
};

export const useUserPermissionsQuery = () => {
  return useQuery({
    queryKey: [QueryKeys.permissions],
    queryFn: () => UserApi.listPermissions(),
    select: (response) => response.data.data,
  });
};

export const useRoleCreateMutation = () => {
  return useMutation({
    mutationFn: (data: IRoleCreate) => UserApi.createRole(data),
  });
};
export const useRoleUpdateMutation = () => {
  return useMutation({
    mutationFn: (data: IRoleUpdate) => UserApi.updateRole(data),
  });
};

export const useRoleDeleteMutation = () => {
  return useMutation({
    mutationFn: (roleId: number) => UserApi.deleteRole(roleId),
  });
};

